export const OC_SPECIAL_OFFERS = {
  desktop: `<div class="cui-grid cui-container -spacing--bottom-64">
  <div class="cui-skeleton-rectangle -is--block -spacing--top-40 -spacing--bottom-64">
    <div class="cui-skeleton__item" style="width: 100%; height: 24px;"></div>
  </div>
  <div class="cui-skeleton-heading -size--large -spacing--top-24 -spacing--bottom-80 -resolution--desktop">
    <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>
  <div class="cui-skeleton-heading -size--medium -spacing--top-160 -spacing--bottom-40 -resolution--desktop">
    <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
    </div>
  </div>
  <div class="cui-grid">
  <div class="cui-container">
    <div class="cui-row">
      <div class="cui-col-sm-1">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 390px;"></div>
        </div>
      </div>
      <div class="cui-col-sm-1">
        <div class="cui-skeleton-heading -size--medium -resolution--desktop">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 390px;"></div>
          </div>
        </div>
      </div>
      <div class="cui-col-sm-1">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 390px;"></div>
        </div>
      </div>
      <div class="cui-col-sm-1">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 390px;"></div>
        </div>
      </div>
    </div>
    </div>
  </div>
</div>`
};
